import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Routes from './routes'
import { applyTheme, cachedTheme } from './theme'

// Inter is self-hosted: no third-party font CDN may be reached from a signing page, and the same
// rule is applied to every surface so the ceremony never diverges from the app (ux.md §1).
import '@fontsource-variable/inter'
// The wordmark's script face for the word "Sign" (packages/ui/src/components/brand.tsx), the 700
// weight only. Self-hosted for the same reason as Inter; the ceremony entry does not load it
// because the ceremony never draws our wordmark — it draws the sender's mark (ADR 0081).
import '@fontsource/dancing-script/700.css'
import './styles.css'

// The reader's light/dark choice, on the document BEFORE React renders (theme.ts).
//
// It used to be applied when the app shell mounted, which is after sign-in — so the sign-in page
// itself painted the operating system's preference and ignored a choice made in this very browser.
// That is the screen where it shows most: the panel is nothing but the mark and the wordmark, and
// the plate under the mark is a theme token (`--brand-plate-solid`). Applied here, the whole entry
// — auth routes and console alike — opens in the reader's theme, and the shell still reconciles
// against the account's stored preference when it mounts.
//
// Before `createRoot`, not inside an effect: an attribute written after the first paint is a flash.
// The ceremony has its own entry and does not run this; it is pinned light (ADR 0081).
applyTheme(cachedTheme())

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <Routes />
  </StrictMode>,
)
